import React from "react";
import { useLocation } from "react-router-dom";

const formatCurrency = (n) =>
  Number.isFinite(n)
    ? new Intl.NumberFormat("he-IL", { style: "currency", currency: "ILS" }).format(n)
    : "";

export default function GiftThankYou() {
  const { state } = useLocation() || {};
  const amount = state?.amount;
  const couple = state?.couple;

  return (
    <div
      dir="rtl"
      className="min-h-screen bg-gray-50 flex items-center justify-center px-4"
      style={{ fontSize: 16 }} /* בסיס יציב ל-rem אם יש שינויים גלובליים */
    >
      <div className="max-w-3xl w-full bg-white rounded-2xl shadow p-10 text-center">
        <h1
          className="font-extrabold mb-6 text-[64px] md:text-[96px] leading-tight"
          style={{ fontSize: "64px" }}
        >
          תודה! 🎉
        </h1>

        <p
          className="font-extrabold text-gray-900 mb-6 leading-snug text-[44px] md:text-[64px]"
          style={{ fontSize: "44px" }}
        >
          המתנה התקבלה בהצלחה
          {couple
            ? ` עבור ${couple.bride_name || ""}${
                couple.groom_name ? " & " + couple.groom_name : ""
              }`
            : ""}
          .
        </p>

        {Number.isFinite(amount) && (
          <p
            className="text-gray-800 leading-snug text-[24px] md:text-[32px]"
            style={{ fontSize: "24px" }}
          >
            סכום שחויב:{" "}
            <strong className="font-bold">{formatCurrency(amount)}</strong>
          </p>
        )}
      </div>
    </div>
  );
}
